import styled from '@emotion/styled';

import type {CSSProperties} from 'react';
import type {ButtonProps} from '../types';

export const Content: React.FC<Pick<ButtonProps, 'children' | 'isLoading'>> = ({children, isLoading}) => {
  const style: CSSProperties = {
    visibility: isLoading ? 'hidden' : undefined,
    padding: typeof children === 'string' ? '0 4px' : undefined,
  };

  return <div style={style}>{children}</div>;
};

const IconContentComponent = styled.div`
  display: flex;
  & svg {
    vertical-align: top;
  }
`;

export const IconContent: React.FC<Pick<ButtonProps, 'children' | 'isLoading'>> = ({children, isLoading}) => {
  const style: CSSProperties = {
    visibility: isLoading ? 'hidden' : undefined,
  };

  return <IconContentComponent style={style}>{children}</IconContentComponent>;
};
